<template>
  <div
    class="ce-formulationAttachments"
    v-if="formulation.attachments && formulation.attachments.length > 0">
    <h2>
      {{ $t('formulationRepository.detailPage.attachments.headline') }}
    </h2>

    <table class="ce-formulationAttachments-table">
      <tbody>
        <FormulationAttachment
          v-for="attachment in formulation.attachments"
          :key="`attachment-${attachment.id}`"
          :attachment="attachment" />
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FormulationAttachment from 'components/formulation-repo/detail-page/FormulationAttachment.vue';

export default {
  computed: {
    ...mapState(['formulation']),
  },
  components: { FormulationAttachment },
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-formulationAttachments {
  .ce-formulationAttachments-table {
    border-spacing: 0;
  }
}

</style>
